module.exports = __webpack_public_path__ + "static/digital-insurance-2b47ee81ae684eba81335593aabb5d6e.png";